export const STEP_EVENTS = {
  onLoadStep: 'onLoadStep',
  onLeaveStep: 'onLeaveStep',
  onNextStep: 'onNextStep',
  onPreviousStep: 'onPreviousStep',
};
